export const OUTCOME_ACCOUNT_TYPE = "הוצאה" as const;
export const OUTCOMES_PATH = "/outcomes";
export const OUTCOMES_BREADCRUMB = { ledger: "כרטסות", list: "הוצאות" } as const;
export const OUTCOMES_STRUCTURE_CRUMBS = {
  search: "הגדרת מבנה חיפוש",
  browse: "הגדרת מבנה דפדוף",
} as const;
export const SEARCH_TABLE_STYLE = {
  backgroundColor: "rgb(35, 48, 68)",
  padding: 5,
  marginButton: 20,
} as const;
